import { connect } from 'react-redux'
import { compose } from 'redux'
import withType from 'components/common/hoc/withType'
import { handleNavigationBack } from './actions'
import BOTBreadcrumbBackGlobalSearch from './BOTBreadcrumbBackGlobalSearch'

const mapDispatchToProps = (dispatch, { baseLink: { path } = {}}) => ({
  handleNavigationBack() {
    dispatch(handleNavigationBack(path))
  }
})

export default compose(
  withType({ type: 'BOTBreadcrumbBackGlobalSearch' }),
  connect(null, mapDispatchToProps)
)(BOTBreadcrumbBackGlobalSearch)
